export default {
  token:
  localStorage.getItem("token") != null
      ? localStorage.getItem("token")
      : null,
};
